import {
  AriaLiveRegion,
  Button,
  Text,
} from "@bluebottlecoffee/design-system/components";
import { FunctionComponent, useEffect, useRef } from "react";

export interface OTPFormProps {
  successMessage: string | null;
  errorMessage: string | null;
  pleaseSubmit: string;
  submitLabel: string;
  loadingText: string;
  code: string;
  onCodeChange: (code: string) => void;
  isLoading: boolean;
  onSubmit: () => void;
  /**
   * reference to an element outside of the form, otherwise defaults to pleaseSubmit
   */
  headingId?: string;
}

const OTPForm: FunctionComponent<OTPFormProps> = ({
  successMessage,
  errorMessage,
  pleaseSubmit,
  submitLabel,
  loadingText,
  code,
  onCodeChange,
  isLoading,
  onSubmit,
  headingId = pleaseSubmit,
}) => {
  const successMessageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (successMessage) {
      successMessageRef.current?.focus();
    }
  }, [successMessage]);

  return (
    <>
      <Text as="h3" className="mb-md" text={pleaseSubmit} id={headingId} />
      {!successMessage && (
        <div className="max-w-sm text-center w-full">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit();
            }}
          >
            <input
              aria-labelledby={headingId}
              className="border border-greyLight mb-md p-sm text-center text-grey uppercase w-full"
              maxLength={6}
              onChange={(e) => onCodeChange(e.target.value)}
              value={code}
            />
            <Button
              attributes={{ "data-test-id": "otp-submit-button" }}
              className="mb-md"
              inactive={isLoading || code === ""}
              isLoading={isLoading}
              isLoadingAssertive
              loadingMessage={loadingText}
              overrideWidth
              submit
            >
              {submitLabel}
            </Button>
          </form>
        </div>
      )}
      {/* Explicitly move focus here on success to avoid getting kicked out to
      body and missing the announcement when this is rendered in a modal */}
      <div ref={successMessageRef} tabIndex={-1} className="focus:outline-none">
        <AriaLiveRegion
          id="otp-status-message"
          assertion="assertive"
          textColor={errorMessage ? "red" : "green"}
          message={successMessage || errorMessage || ""}
        />
      </div>
    </>
  );
};

export default OTPForm;
